import React from 'react';
import EditKnockout from '../../components/knockout/edit-knockout';

const EditKnockoutContainer = () => {
    return <EditKnockout />;
};

export default EditKnockoutContainer;
